import type from './component.type';

const initialState = {
  poListData: [],
  totalPOCount: 0,
  editData: null,
  pOrderData: [],
  totalOrderCount: 0,
  zipUrl: '',
  supplierType: [],
  supplierList: [],
  pODetailData: [],
  userContactData: [],
  UnitOfMeasure: [],
  poDocumets: [],
};

const ComponentConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_TEMPLATE_DETAILS:
      return {
        ...state,
        poListData: action.payload?.doc,
        totalPOCount: action.payload?.totalCount,
      };
    case type.CLEAR_REDUCER_TEMPLATE:
      return {
        ...state,
        totalPOCount: 0,
        poListData: [],
        editData: null,
        pOrderData: [],
        totalOrderCount: 0,
        zipUrl: '',
        supplierType: [],
        supplierList: [],
      };
    case type.GET_EDIT_DATA:
      return {
        ...state,
        editData: action.payload,
      };
    case type.FETCH_PURCHASE_ORDER:
      return {
        ...state,
        pOrderData: action.payload.doc,
        totalOrderCount: action.payload?.totalCount,
      };
    case type.DOWNLOAD_ZIP_URL:
      return {
        ...state,
        zipUrl: action.payload,
      };
    case type.SUPPLIER_TYPE:
      return {
        ...state,
        supplierType: action.payload,
      };
    case type.SUPPLIER_LIST:
      return {
        ...state,
        supplierList: action.payload,
      };
    case type.PURCHASE_ORDER_BY_ID:
      return {
        ...state,
        pODetailData: action.payload,
      };
    case type.CONTACT_USER_DATA:
      return {
        ...state,
        userContactData: action.payload,
      };
    case type.FETCH_UNIT_OF_MEASURE:
      return {
        ...state,
        UnitOfMeasure: action.payload,
      };
    case type.FETCH_UPLOAD_DOCUMENTS:
      return {
        ...state,
        poDocumets: action.payload,
      };
    case type.SET_CREATED_BY_USER:
      return {
        ...state,
        createdByUser: action.payload,
      };
    default:
      return state;
  }
};

export default ComponentConfigReducer;
